import { DeepPartial } from '@apollo/client/utilities'
import { EmployeeTableViewRowFragment, TeamTableViewRowFragment } from 'generated/resources/graphql'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import buildUrl from 'modules/core/lib/buildUrl'

type UseEmployeeTableViewRowParams = {
  title: string
  employee?: EmployeeTableViewRowFragment | DeepPartial<EmployeeTableViewRowFragment> | null
}

export const useEmployeeTableViewRow = ({ title, employee }: UseEmployeeTableViewRowParams) => {
  const { navigation } = useNavigation()

  if (!employee || !employee.id || !employee.firstName) {
    return
  }

  const firstName = employee.preferredName || employee.firstName
  const lastName = employee.lastName ?? ''

  if (!firstName) {
    return
  }

  const avatarUrl = employee.avatar?.url ? buildUrl(employee.avatar.url) : undefined

  return {
    title,
    content: {
      action: {
        href: navigation.employees.id.fullPath({ id: employee.id }),
        type: 'navigate' as const,
      },
      avatarUrl,
      firstName,
      lastName,
      type: 'person' as const,
    },
  }
}

export type EmployeeTableViewRow = ReturnType<typeof useEmployeeTableViewRow>

type UseTeamTableViewRowParams = {
  title: string
  team?: TeamTableViewRowFragment | DeepPartial<TeamTableViewRowFragment> | null
}

export const useTeamTableViewRow = ({ title, team }: UseTeamTableViewRowParams) => {
  const { navigation } = useNavigation()

  if (!team || !team.id || !team.name) {
    return
  }

  return {
    title,
    content: {
      action: {
        href: navigation.employees.teams.id.fullPath({ id: team.id }),
        type: 'navigate' as const,
      },
      name: team.name,
      type: 'team' as const,
    },
  }
}
